/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { UpdateStatusSongClueRequest } from '../models/update-status-song-clue.request';
import { AnswerSongClueRequest } from '../models/answer-song-clue.request';
import { ObtainTurnSongClueRequest } from '../models/obtain-turn-song-clue.request';
import { SongClue } from '../models/song-clue.entity';

export type SongClueUpdatePathVariables = {
	gameId: string;
	songRoundId: string;
	id: string;
};

@Injectable()
export class SongClueService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public update(
		path: SongClueUpdatePathVariables,
		body:
			| UpdateStatusSongClueRequest
			| AnswerSongClueRequest
			| ObtainTurnSongClueRequest,
	): Observable<SongClue | void> {
		return this.http.patch<SongClue | void>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/song/rounds/${path.songRoundId}/clues/${path.id}`,
			body,
		);
	}
}
